// extracted by mini-css-extract-plugin
export default {"notificationAnchor":"MagicUploadNotifications_notificationAnchor__lNf5w"};